import { getGuideUrl } from '@change-corgi/config/guides';
import { useI18n } from '@change-corgi/core-react/i18n';

import { useLocale } from 'src/app/shared/hooks/l10n';

export type GuideLink = Readonly<{
	title: string;
	guideLink: string;
}>;

export function useGuideLinks(): readonly GuideLink[] | null {
	const { translate } = useI18n();
	const locale = useLocale();

	const createPetitionLink = getGuideUrl(locale, 'createPetition');
	const sharePetitionLink = getGuideUrl(locale, 'sharePetition');
	const reachMediaLink = getGuideUrl(locale, 'reachMedia');
	const engageDecisionMakerLink = getGuideUrl(locale, 'engageDecisionMaker');

	if (!createPetitionLink || !sharePetitionLink || !reachMediaLink || !engageDecisionMakerLink) {
		return null;
	}

	return [
		{
			title: translate('corgi.components.footer.links.create_petition'),
			guideLink: createPetitionLink,
		},
		{
			title: translate('corgi.components.footer.links.collect_signatures'),
			guideLink: sharePetitionLink,
		},
		{
			title: translate('corgi.components.footer.links.reach_out_to_media'),
			guideLink: reachMediaLink,
		},
		{
			title: translate('corgi.components.footer.links.engage_decision_maker'),
			guideLink: engageDecisionMakerLink,
		},
	];
}
